/**
 * @fileoverview Prompt template for chapter-entity-detector-v2.
 */

export const prompt = `
You are an expert literary analyst AI.

## TASK INSTRUCTIONS:
Your task is to read the following text from a single chapter of a novel and identify:
1. All the named **characters** who have a meaningful presence.
2. All the known **world elements** that have a meaningful presence.

### Character Detection Rules:
- A meaningful presence means the character speaks, performs an action, or is the focus of a description.
- Do not include characters who are only mentioned in passing without any impact on the scene.
- Do not include groups of people (e.g., "the guards," "the crowd").

### Character Relevance:
Check the list of known characters given below and look for matches with the characters you found.
- For identified characters that match an entry from the list (exact or partial match), return the **exact name** from the KNOWN CHARACTERS list. Do not append aliases, nicknames, or parenthetical descriptions to the name.
- For all others (characters not in the known list), return the most complete name you can derive from the text.

### World Element Detection Rules:
- A meaningful presence means the world element is a location where a scene takes place, an object that is used or described, an event that is referenced with significance, an organization that plays a role, or any other element that contributes to the scene beyond a passing mention.
- Do not include world elements that are only mentioned in passing without any relevance to the scene.

### World Element Relevance
- For identified elements that match an entry from the list, return the **exact name** and **type** from the KNOWN WORLD ELEMENTS list.
- Only include world elements that appear in the KNOWN WORLD ELEMENTS list. Do not output any other world elements, even you you detected them.

## CHAPTER CONTENT TO ANALYZE:
{{{chapterContent}}}

## AVAILABLE CONTEXT
<<<knownCharacters>>>
<<<knownWorldElements>>>

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
